import { computed, inject, Injectable, signal } from '@angular/core';
import { StoreService } from './store.service';
import { StoreLiteDto } from '../models/store.models';

const STORAGE_KEY = 'bepos_selected_store_id';

@Injectable({ providedIn: 'root' })
export class StoreContextService {
  private storeService = inject(StoreService);

  private _stores = signal<StoreLiteDto[]>([]);
  private _selectedId = signal<string | null>(this.readStoredId());

  stores = this._stores.asReadonly();
  selectedStoreId = this._selectedId.asReadonly();

  selectedStore = computed(() => {
    const id = this._selectedId();
    return this._stores().find((s) => s.id === id) ?? null;
  });

  loadStores(): void {
    this.storeService.getAllLite().subscribe({
      next: (res) => {
        const list = res.data ?? [];
        this._stores.set(list);
        const sid = this._selectedId();
        if (sid && !list.some((s) => s.id === sid)) {
          this.setSelectedStoreId(list[0]?.id ?? null);
        } else if (!sid && list.length === 1) {
          this.setSelectedStoreId(list[0].id);
        }
      },
      error: () => this._stores.set([]),
    });
  }

  setSelectedStoreId(id: string | null): void {
    this._selectedId.set(id);
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  private readStoredId(): string | null {
    return localStorage.getItem(STORAGE_KEY);
  }
}
